import { updateField, getField } from 'vuex-map-fields'
import api from '../api'

const state = {

	notifications: {
		data: [],
		current_page: 0,
		last_page: 0,
		total: 0
	},
	notificationLoading: false,

	errors: {
		title: '',
		description: '',
		dateTime: '',
		age: ''
	},

	notification: {
		title: '',
		description: '',
		date: '',
		time: '',
		gender: [],
		ageFrom: 0,
		ageTo: 0,
		users: [],
		country: []
	},

	oldNotification: {
		title: '',
		description: '',
		date: '',
		time: '',
		gender: [],
		ageFrom: 0,
		ageTo: 0,
		users: [],
		country: []
	},

	buttonLoading: false,

	userList: {
		current_page: 0,
		last_page: 0,
		data: []
	},
	userListLoading: false,

	countryList: {
		current_page: 0,
		last_page: 0,
		data: []
	},
	countryListLoading: false,

	userViewList: {
		data: []
	},
	userViewLoading: false,

	userFilter: {
		country: false,
		age: false,
		gender: false,
		keyword: ''
	},

	countryKeyword: ''
}

const mutations = {
	updateField
}

const actions = {
	async getList ({ state }, payload) {
		state.notificationLoading = true

		const { data, status } = await api('get', `notification/list${payload}`)

		if (status) {
			state.notifications = data.data
			state.notificationLoading = false
			return
		}

		state.notificationLoading = false
	},

	async create ({ state, dispatch }, payload) {
		state.buttonLoading = true

		const { status } = await api('post', 'notification/create', payload.form)

		if (status) {
			await dispatch('clearData')
			payload.router.push({ name: 'notification-post' })
			payload.store.dispatch('toggleBanner', {
				status: true,
				message: 'Notification is successfully created.',
				type: 'success'
			})
			state.buttonLoading = false
			return
		}

		state.buttonLoading = false
	},

	async edit ({ state }, payload) {
		state.buttonLoading = true

		const { data, status } = await api('get', `notification/view?id=${payload}`)

		if (status) {
			const {
				title,
				description,
				age_from,
				age_to,
				gender,
				notification_date,
				users,
				country
			} = data.data
			const [ date, time ] = notification_date.split(' ')
			state.notification.title = title
			state.notification.description = description
			state.notification.gender = gender.map(item => {
				return { value: item }
			})
			state.notification.ageFrom = age_from
			state.notification.ageTo = age_to
			state.notification.users = users
			state.notification.country = country.map(item => {
				return { country: item }
			})
			state.userFilter.age = !!(age_from && age_to)
			state.userFilter.country = !!country.length
			state.userFilter.gender = !!gender.length
			state.notification.date = new Date(date)
			state.notification.time = new Date(`${date} ${time}`)

			state.buttonLoading = false
			return
		}

		state.buttonLoading = false
	},

	async update ({ state, dispatch }, payload) {
		state.buttonLoading = true

		const { status } = await api('post', 'notification/update', payload.form)

		if (status) {
			await dispatch('clearData')
			payload.router.push({ name: 'notification-post' })
			payload.store.dispatch('toggleBanner', {
				status: true,
				message: 'Notification is successfully updated.',
				type: 'success'
			})
			state.buttonLoading = false
			return
		}

		state.buttonLoading = false
	},

	async delete ({ state }, payload) {
		state.buttonLoading = true

		const { data, status } = await api('post', `notification/delete${payload}`)

		if (status) {
			state.notifications = data.data
			state.buttonLoading = false
			return
		}

		state.buttonLoading = false
	},

	async getCountryList ({ state }, payload) {
		state.countrListLoading = true

		const { data, status } = await api('get', `notification/country-list${payload}`)

		if (status) {
			state.countryList.data = [...state.countryList.data, ...data.data.data]
			state.countryList.current_page = data.data.current_page
			state.countryList.last_page = data.data.last_page
			state.countryListLoading = false
			return
		}

		state.countrListLoading = false
	},

	async getUserList ({ state }, payload) {
		state.userListLoading = true

		const { data, status } = await api('get', `notification/user-list${payload}`)

		if (status) {
			state.userList.data = [...state.userList.data, ...data.data.data]
			state.userList.current_page = data.data.current_page
			state.userList.last_page = data.data.last_page
			state.userListLoading = false
			return
		}

		state.userListLoading = false
	},

	async viewUser ({ state }, payload) {
		state.userViewLoading = true

		const { data, status } = await api('get', `notification/view-user${payload}`)

		if (status) {
			state.userViewList = data.data
			state.userViewLoading = false
			return
		}

		state.userViewLoading = false
	},

	hasValues ({ state }) {
		const {
			title,
			description,
			date,
			time,
			gender,
			ageFrom,
			ageTo,
			users,
			country
		} = state.notification

		return ageTo ||
				ageFrom ||
				date ||
				time ||
				gender.length ||
				users.length ||
				description.trim() !== '' ||
				title.trim() !== '' ||
				country.length
	},

	async hasChanges ({ state, dispatch }) {
		const {
			title,
			description,
			date,
			time,
			gender,
			ageFrom,
			ageTo,
			users,
			country
		} = state.notification

		const hasValues = await dispatch('hasValues')

		if (!hasValues) return false

		const oldGender = state.oldNotification.gender.map(item => item.text)
		const oldUsers = state.oldNotification.users.map(item => item.id)
		const oldCountry = state.oldNotification.country.map(item => item.country)
		const oldDate = new Date(state.oldNotification.date).valueOf()
		const newDate = new Date(date).valueOf()
		const oldTime = new Date(state.oldNotification.time).valueOf()
		const newTime = new Date(time).valueOf()

		return ageTo !== state.oldNotification.ageTo ||
			ageFrom !== state.oldNotification.ageFrom ||
			newDate !== oldDate ||
			newTime !== oldTime ||
			gender.some(item => !oldGender.includes(item.text)) ||
			users.some(item => !oldUsers.includes(item.id)) ||
			country.some(item => !oldCountry.includes(item.country)) ||
			description !== state.oldNotification.description ||
			title !== state.oldNotification.title
	},

	async clearData ({ state }) {
		state.notification = {
			title: '',
			description: '',
			date: '',
			time: '',
			gender: [],
			ageFrom: '',
			ageTo: 0,
			users: [],
			country: []
		}

		state.oldNotification = {
			title: '',
			description: '',
			date: '',
			time: '',
			gender: [],
			ageFrom: '',
			ageTo: 0,
			users: [],
			country: []
		}

		state.userFilter = {
			country: false,
			age: false,
			gender: false,
			keyword: ''
		}
		state.countryKeyword = ''

		state.userList = {
			current_page: 0,
			last_page: 0,
			data: []
		}
		state.countryList = {
			current_page: 0,
			last_page: 0,
			data: []
		}

		state.errors = {
			title: '',
			description: '',
			dateTime: '',
			age: ''
		}
	}
}

const getters = {
	getField
}

export default {
	state,
	namespaced: true,
	mutations,
	actions,
	getters
}
